import { render, staticRenderFns } from "./TypeUser.vue?vue&type=template&id=631ce684"
import script from "./TypeUser.vue?vue&type=script&lang=js"
export * from "./TypeUser.vue?vue&type=script&lang=js"
import style0 from "./TypeUser.vue?vue&type=style&index=0&id=631ce684&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports